<div class="question">

  <div class="question-panel">

    <div class="form-group">
      <label>Would you like to extend this cover to include cover for losses from staff's personal accounts?</label>

      <label class="custom-input custom-input--radio">
        <input type="radio" name="radio-pill-example[]">
        <span class="custom-input__indi"></span>
        <span class="custom-input__label">No, thanks</span>
      </label>

      <label class="custom-input custom-input--radio">
        <input type="radio" name="radio-pill-example[]">
        <span class="custom-input__indi"></span>
        <span class="custom-input__label">Option 1</span>
      </label>

      <div class="mt-10 mb-15 ml-30">
        <ul class="data data--options">
          <li class="data__row">
            <label class="data__label"> Theft of Funds </label>
            <div class="data__cell data__cell--right"> Up to <strong>R 50 000</strong> </div>
          </li>
          <li class="data__row">
            <label class="data__label"> Identity Theft </label>
            <div class="data__cell data__cell--right"> Up to <strong>R 20 000</strong> </div>
          </li>
          <li class="data__row">
            <label class="data__label"> Data Restoration </label>
            <div class="data__cell data__cell--right"> Up to <strong>R 20 000</strong> </div>
          </li>
          <li class="data__row">
            <label class="data__label"> Cyber Extortion </label>
            <div class="data__cell data__cell--right"> Up to <strong>R 5 000</strong> </div>
          </li>
          <li class="data__row">
            <label class="data__label"> Online Sales and Shopping </label>
            <div class="data__cell data__cell--right"> Up to <strong>R 1 000</strong> </div>
          </li>
        </ul>
      </div>

      <label class="custom-input custom-input--radio">
        <input type="radio" name="radio-pill-example[]">
        <span class="custom-input__indi"></span>
        <span class="custom-input__label">Option 2</span>
      </label>


      <div class="mt-10 mb-15 ml-30">
        <ul class="data data--options">
          <li class="data__row">
            <label class="data__label"> Theft of Funds </label>
            <div class="data__cell data__cell--right"> Up to <strong>R 50 000</strong> </div>
          </li>
          <li class="data__row">
            <label class="data__label"> Identity Theft </label>
            <div class="data__cell data__cell--right"> Up to <strong>R 20 000</strong> </div>
          </li>
          <li class="data__row">
            <label class="data__label"> Data Restoration </label>
            <div class="data__cell data__cell--right"> Up to <strong>R 20 000</strong> </div>
          </li>
          <li class="data__row">
            <label class="data__label"> Cyber Extortion </label>
            <div class="data__cell data__cell--right"> Up to <strong>R 5 000</strong> </div>
          </li>
          <li class="data__row">
            <label class="data__label"> Online Sales and Shopping </label>
            <div class="data__cell data__cell--right"> Up to <strong>R 1 000</strong> </div>
          </li>
        </ul>
      </div>






    </div>

  </div>


</div>